<template>
    <div class="flex flex-col ml-2 text-slate-300">
        <div
            class="flex justify-center items-center h-4 w-5 px-1 pt-1 rounded hover:bg-slate-100 transition-colors"
            :class="{
                'text-slate-800': direction === 'asc' && activeSort === column,
            }"
            @click="() => handleSort('asc')"
        >
            <Icon icon="chevron-up" />
        </div>
        <div
            class="flex justify-center items-center h-4 w-5 px-1 pb-1 rounded hover:bg-slate-100 transition-colors"
            :class="{
                'text-slate-800': direction === 'desc' && activeSort === column,
            }"
            @click="() => handleSort('desc')"
        >
            <Icon icon="chevron-down" />
        </div>
    </div>
</template>
<script>
import { computed } from 'vue';
import Icon from '@/components/ui/icon/icon.vue';
export default {
    components: {
        Icon,
    },
    props: {
        direction: String,
        activeSort: String,
        column: String,
    },
    emits: ['sort-changed'],
    setup(props, { emit }) {
        const handleSort = (dir) => {
            emit('sort-changed', dir, props.activeSort);
        };
        const icon = computed(() =>
            props.direction === 'asc' ? 'chevron-up' : 'chevron-down'
        );
        return { handleSort, icon };
    },
};
</script>
